<template>
  <v-fade-transition mode="out-in">
    <router-view v-if="ready" />
    <div v-else class="app-boot" role="status" aria-label="Loading">
      <v-progress-circular indeterminate color="primary" size="32" width="3" />
    </div>
  </v-fade-transition>
  <!-- Every page's toasts (useToast), including the sign-in pages. -->
  <UiToaster />
</template>

<script>
import { areaFor, homePathFor, loadSession } from '@/api/session';
import UiToaster from '@/components/ui/UiToaster.vue';

// Restores the session on start-up. The page stays on a small spinner until
// the user behind a stored token is known, so a signed-in user never sees
// the login form flash before their dashboard.
export default {
  name: 'App',
  components: { UiToaster },
  data: () => ({
    ready: false,
  }),
  async created() {
    // Sign-in links can carry the token in the URL (?token=…).
    const token = new URLSearchParams(window.location.search).get('token');
    if (token) {
      localStorage.setItem('token', token);
      this.$store.commit('setExpiryDate');
      this.$store.dispatch('setIsAuthenticated', 0);
    }

    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setIsAuthenticated', 0);
      this.ready = true;
      return;
    }

    if (this.$store.getters.getIsAuthenticated == 1 && this.$store.state.user) {
      // Already signed in (e.g. a page refresh): show the page now and
      // refresh the user in the background.
      this.ready = true;
      try {
        const user = await loadSession(this.$store);
        if (!user) {
          localStorage.removeItem('token');
          this.$router.replace('/login');
        } else if (this.$route.path.split('/')[1]?.toLowerCase() !== areaFor(user) && this.$route.meta.authRequired) {
          // The refreshed user belongs in another area (e.g. a parent saved
          // before parents left /employee).
          this.$router.replace(homePathFor(user));
        }
      } catch {
        // Server unreachable: keep the saved session and try again later.
      }
      return;
    }

    if (localStorage.getItem('token')) {
      try {
        const user = await loadSession(this.$store);
        if (user) await this.$router.replace(homePathFor(user));
        else localStorage.removeItem('token');
      } catch {
        // Server unreachable: show the page; signing in will retry.
      }
    }
    this.ready = true;
  },
};
</script>
<style>
.app-boot {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--background);
}

/* SCROLL BAR CUSTOMIZE*/
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
/* Theme tokens so the scrollbar suits light and dark mode */
::-webkit-scrollbar-thumb {
  background: var(--border-strong);
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--faint-foreground);
}
</style>
